import { Badge, Button } from '@artosera/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useListesNewsletter,
  useArchiverListe,
  type ListeNewsletter,
} from '../../api/newsletter.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ListeDialog } from './ListeDialog.js';
import { RegleListe } from './RegleListe.js';
import styles from './NewsletterPage.module.css';
import { Verrouillable } from '../module/LectureSeule.js';
export function ListesTab() {
  const { t } = useTranslation(['regie', 'commun', 'contacts']);
  const { galerieSlug, galerie } = useShellContext();
  const listes = useListesNewsletter(galerieSlug);
  const archiver = useArchiverListe(galerieSlug);
  const [ouverte, setOuverte] = useState(false);
  const [aModifier, setAModifier] = useState<ListeNewsletter | null>(null);
  const ecriture = galerieALaction(galerie, 'newsletter:write');
  return (
    <section className={styles.section} data-ui="newsletter-lists">
      <Verrouillable action="newsletter:write" ouvert={ecriture}>
        <Button onClick={() => setOuverte(true)}>{t('regie:newsletter.listes.nouvelle')}</Button>
      </Verrouillable>
      {listes.isPending ? <p>{t('commun:chargement')}</p> : null}
      {listes.isError || archiver.isError ? <p role="alert">{t('commun:erreurReseau')}</p> : null}
      <div className={styles.grille}>
        {listes.data?.listes.map((l) => (
          <article key={l.id} className={styles.carte}>
            <h2>{l.nom}</h2>
            <p>{l.description}</p>
            <p>
              <RegleListe regle={l.regle} />
            </p>
            <p>{t('regie:newsletter.listes.destinataires', { count: l.membres })}</p>
            {l.synchronisee ? <Badge>{t('regie:newsletter.listes.synchronisee')}</Badge> : null}
            <div className={styles.actions}>
              <Verrouillable action="newsletter:write" ouvert={ecriture}>
                <Button variant="secondary" onClick={() => setAModifier(l)}>
                  {t('regie:newsletter.listes.modifier')}
                </Button>
              </Verrouillable>
              <Verrouillable action="newsletter:write" ouvert={ecriture}>
                <Button
                  variant="ghost"
                  disabled={archiver.isPending}
                  onClick={() => archiver.mutate(l.id)}
                >
                  {t('regie:newsletter.listes.archiver')}
                </Button>
              </Verrouillable>
            </div>
          </article>
        ))}
      </div>
      {listes.data && !listes.data.listes.length ? (
        <p className={styles.vide}>{t('regie:newsletter.listes.vide')}</p>
      ) : null}
      <ListeDialog open={ouverte} onOpenChange={setOuverte} />
      <ListeDialog
        open={aModifier !== null}
        onOpenChange={(v) => {
          if (!v) setAModifier(null);
        }}
        liste={aModifier}
      />
    </section>
  );
}
